import { tsValidateArray, tsValidateNumber, tsValidateOptionalId, tsValidateUniqueId } from '@nu-art/ts-common';
export const Validator_OrgPermissions_GeneratedProps = {
    meta: {
        read: tsValidateArray(tsValidateUniqueId),
        write: tsValidateArray(tsValidateUniqueId),
        createdBy: tsValidateOptionalId,
        modified: tsValidateArray({
            user: tsValidateUniqueId,
            timestamp: tsValidateNumber()
        }, false),
    }
};
//# sourceMappingURL=types.js.map